const isValueDefined = <TValue>(
  value: TValue
): value is NonNullable<TValue> => {
  return value !== undefined && value !== null;
};

export class Maybe<TValue> {
  private readonly _value: TValue;

  private constructor(value: TValue) {
    this._value = value;
  }

  public static from = <TMaybeValue>(
    value: TMaybeValue
  ): Maybe<TMaybeValue> => {
    return new Maybe<TMaybeValue>(value);
  };

  /**
   * Returns the inner value if there's one, otherwise returns `defaultValue`
   */
  public getValueOrDefault = (
    defaultValue: NonNullable<TValue>
  ): NonNullable<TValue> => {
    if (isValueDefined(this._value)) {
      return this._value;
    }

    return defaultValue;
  };

  /**
   * Returns the inner value if there's one, otherwise throws an Error with `errorMessage`
   */
  public getValueOrThrow = (
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    errorMessage: string = 'Maybe has no value.'
  ): NonNullable<TValue> => {
    if (isValueDefined(this._value)) {
      return this._value;
    }

    throw new Error(errorMessage);
  };
}
